import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetNucleoFamiliar, IGetPerfilUsuario, ISisbenResultadoConsulta } from '../../shared/interfaces/sisben/sisben';

@Injectable({
  providedIn: 'root'
})
export class SisbenConsultaService {
  // environment.apiUrl is the base url of the api
  private readonly baseUrl = `${environment.apiUrl}/api/datasets-dinamicos/sisben`;

  constructor(private readonly http: HttpClient) { }

  /**
   * Realiza una consulta en SISBEN con base en un parámetro de búsqueda
   * @param search Parámetro de búsqueda (tipo identificación, identificación o nombre)
   * @param tipoIdentificacion ID del tipo de identificación
   * @returns Observable con la lista de resultados de consulta SISBEN
   */
  sisbenResultadoConsulta(search: string, tipoIdentificacion: number): Observable<ISisbenResultadoConsulta[]> {
    return this.http.get<ISisbenResultadoConsulta[]>(`${this.baseUrl}/consulta`, {
      params: { search, tipoIdentificacion }
    });
  }

  /**
   * Obtiene el perfil de un usuario SISBEN por su ID
   * @param id ID del usuario SISBEN
   * @returns Observable con el perfil del usuario
   */
  getPerfilUsuario(id: number): Observable<IGetPerfilUsuario> {
    return this.http.get<IGetPerfilUsuario>(`${this.baseUrl}/perfil/${id}`);
  }

  /**
   * Obtiene el núcleo familiar de un usuario SISBEN por su ID
   * @param id ID del usuario SISBEN
   * @returns Observable con la lista de miembros del núcleo familiar
   */
  getNucleoFamiliar(id: number): Observable<IGetNucleoFamiliar[]> {
    return this.http.get<IGetNucleoFamiliar[]>(`${this.baseUrl}/nucleo-familiar/${id}`);
  }
}
